import type { SelectProps } from '@affine/component/ui/select';
import { Select, SelectItem } from '@affine/component/ui/select';
import { UserAccessRole } from '@affine/graphql';
import { useI18n } from '@affine/i18n';

export interface SelectPermissionsProps extends SelectProps {
  value?: UserAccessRole;
  onChange?: (value: UserAccessRole) => void;
  //DNB_FIX
  permissions?: UserAccessRole[] | null;
}

export const SelectPermissions = ({
  selectRoot,
  value,
  onChange,
  //DNB_FIX
  permissions,
}: SelectPermissionsProps) => {
  const t = useI18n();
  //DNB_FIX возможность добавлять пользователей для не Owner
  const renderSelectItem = () => {
    const permissionArray = permissions
      ? permissions
      : [UserAccessRole.Read, UserAccessRole.Write];
    return permissionArray?.map(item => (
      <SelectItem key={item} value={item}>
        {t[item === UserAccessRole.Read ? 'Reader' : 'Editor']()}
      </SelectItem>
    ));
  };

  return (
    <Select
      selectRoot={{
        value,
        defaultValue: UserAccessRole.Read,
        onValueChange: onChange,
        ...selectRoot,
      }}
    >
      {/* DNB_FIX */}
      {renderSelectItem()}
      {/*
        <>
          <SelectItem value={UserAccessRole.Write}>{t['Editor']()}</SelectItem>
          <SelectItem value={UserAccessRole.Read}>{t['Reader']()}</SelectItem>
        </>*/}
    </Select>
  );
};
